import { Dispatch } from "redux";
import { setAxnAdminLoggingRefreshResults, setAxnAdminLoggingRefreshing } from "@redux/actions/axn-admin-logging-actions";
import { refreshAxnAdminLoggingRequest } from "@requests/management-console/refresh-axn-admin-logging";
import { RefreshResult } from "@idw-types/common";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const refreshAxnAdminLoggingReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<RefreshResult>> => {
    dispatch(setAxnAdminLoggingRefreshResults(null, null));
    dispatch(setAxnAdminLoggingRefreshing(true));
    const { data, error } = await refreshAxnAdminLoggingRequest();

    const lastRefreshDate = new Date();

    if (data) {
        dispatch(setAxnAdminLoggingRefreshResults(data, lastRefreshDate));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.refreshAxnAdminLogging.error.title,
                resources.requests.refreshAxnAdminLogging.error.message
            );
        }
        dispatch(setAxnAdminLoggingRefreshResults(null, lastRefreshDate));
        return null;
    }
};